import type AccessIssue from "owa-attachment-policy-access-issue-checker/lib/schema/AccessIssue";
import getConditionalAccessIssue from "owa-attachment-policy-access-issue-checker/lib/utils/getConditionalAccessIssue";
import type { MailboxInfo } from "owa-client-types";
import getModuleContextMailboxInfo from "owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo";
import { isVanityDomain } from "owa-tokenprovider";
import { getApplicationSettings } from "owa-application-settings";
import { isLocalDataBackedMailboxInfo } from "owa-account-source-list/lib/utils/isLocalDataBackedAccount";

export function isMOSLaunchPagesEnabled(mailboxInfo?: MailboxInfo): boolean {
    const mboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();
    const combinedAccessIssue = getConditionalAccessIssue(mboxInfo).shift() ?? 2;
    const isVanityDomainValue = isVanityDomain();
    const isLocalDataAccount = isLocalDataBackedMailboxInfo(mboxInfo);
    
    const mosAppinVanityDomain = !isVanityDomainValue || getApplicationSettings("OwaVanityDomains").enabled;
    
    return combinedAccessIssue === 2 && mosAppinVanityDomain && !isLocalDataAccount;
}
